/**
 * Filter header của grid
 */
export default {
  Contains: 'contains',
  Notcontains: 'notContains',
  StartsWith: 'startsWith',
  EndsWith: 'endsWith',
  Null: 'is null',
  NotNull: 'is not null',
  Equals: '=',
  NotEquals: '!=',
  GreaterThan: '>',
  GreaterThanEquals: '>=',
  LessThan: '<',
  LessThanEquals: '<=',
  Between: '[]',
};
